import styled from 'styled-components'

const AppInfoContainer = styled.div``

export { AppInfoContainer }
